// extracted by mini-css-extract-plugin
export default {"root":"ViewAllPhotos_root__22tAs","rectangles":"ViewAllPhotos_rectangles__j9L26","rectangle":"ViewAllPhotos_rectangle__1ld1Q"};